import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";

import { LinkEntry } from "@/common/contracts/footer.contracts";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { useContentLocale } from "@/i18n/hooks";

type FooterLinkProps = {
  link: LinkEntry;
};

export const FooterLink = ({ link }: FooterLinkProps) => {
  const { t } = useTranslation();
  const locale = useContentLocale();

  const handleClick = () => {
    analyticsService.trackFooterNavigation(link.label);
  };

  const href = typeof link.path === "string" ? link.path : link.path[locale];

  if (link.excludeOnLocals?.includes(locale)) {
    return null;
  }

  return (
    <Link
      href={href}
      prefetch={false}
      sourceLocale="en"
      className="footer-link"
      onClick={handleClick}
      {...(link.externalLink && { target: "_blank" })}
    >
      {link.rawLabel ? link.label : t(link.label)}
    </Link>
  );
};
